export default "__VITE_PUBLIC_ASSET__0501ae25__"